var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"campaign_type",on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.iconSrc)?_c('svg-icon',{attrs:{"src":_vm.iconSrc}}):_vm._e(),_c('div',{staticClass:"campaign_type-text"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }